<template>
  <b-form-group :label="label" :class="{ 'form-group--error': validator.$error }">
    <slot />
    <div v-if="validator.$error">
      <ValidationMessage
        v-for="error in activeErrors"
        :key="error.validationKey"
        :message="getErrorMessage(error.validationKey, error.params)"
      />
    </div>
  </b-form-group>
</template>
<script>
import { extractorMixin } from 'vuelidate-error-extractor';

export default {
  mixins: [extractorMixin]
};
</script>
